export const getPendingCampaigns = (missions = []) =>
  missions.filter((m) => m.status === 'active')

export const getPendingCampaign = (missions = [], missionCode) =>
  getPendingCampaigns(missions).find((m) => m.missionCode === missionCode)

export default 0
